import 'view/css/leave.css';

import moment from 'moment';
import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { Data } from 'service/util';
import Loading from 'component/Loading';
import PopMessage from 'component/pop-msg/PopMessage';
import Protected from 'component/Protected';
import SearchableList from 'component/dropdown/SearchableList';

import DatePicker from 'react-datepicker';

const LeaveTable = ({ leaves, refreshData }) =>
{
  const cancelLeave = (leave) =>
  {
    // confirm user
    if (!window.confirm('確定要取消假期?')) return;

    API.deleteLeave(leave).then(resp => {
      if (resp.success)
      {
        PopMessage.show('已成功刪除員工假期記錄', '成功', 'success');
        refreshData();
      } else {
        PopMessage.show(resp.msg, '錯誤', 'danger');
      }
    });
  }

  if (!leaves?.length) return (
    <p className="message red">沒有任何請假記錄。</p>
  );

  return (
    <table className="table">
      <thead>
        <tr>
          <th>請假日期</th>
          <th>類型</th>
          <Protected allow={['ADMIN']}><th>薪金比例</th></Protected>
          <th>審批人</th>
          <th>審批日</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {leaves.map(l =>
          <tr key={l.leave_dtm}>
            <td>{ Util.ShortDate(l.leave_dtm) }</td>
            <td>{ Util.getLeaveType(l.leave_type) }</td>
            <Protected allow={['ADMIN']}><td>{ l.pay_ratio }</td></Protected>
            <td>{ l.mod_by }</td>
            <td>{ Util.ShortDate(l.mod_dtm) }</td>
            <td>
              <FontAwesomeIcon icon={faTrash} onClick={e=>cancelLeave(l)} className="btn-del" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );

}




const LeaveView = (props) =>
{
  const [sel_staff, setStaff]         = useState(null);
  const [sel_leaveFrom, setFromDate]  = useState(new Date());
  const [sel_leaveTo, setToDate]      = useState(new Date());
  const [sel_leaveType, setLeaveType] = useState(1);
  const [pay_ratio, setPayRatio]      = useState(1);
  const [staff, setStaffList]         = useState([]);
  const [leaves, setLeaves]           = useState([]);
  const [loading, setLoading]         = useState(false);

  const refreshData = () =>
  {
    if (!sel_staff?.id) return false;

    setLoading(true);
    API.getStaffLeave(sel_staff.id).then(resp =>
    {
      if (resp.success) {
        setLeaves(resp.msg);
      } else {
        PopMessage.show(resp.msg, '讀取失敗', 'danger');
      }
      setLoading(false);
    });
  }


  useEffect(() =>
  {
    API.getStaffList().then(staff => {
      setStaffList(staff);
    });
  }, []);

  useEffect(() =>
  {
    let pay_ratio = (() => {
      switch (sel_leaveType)
      {
        case 1:  return 1.0; // 年假 (Annual Leave)
        case 2:  return 0.0; // 事假 (Casual Leave)
        case 3:  return 0.5; // 病假 (Sick Leave)
        case 4:  return 0.0; // 無薪假 (Unpaid Leave)
        case 5:  return 1.0; // 補假/恩恤假 (Compansationate Leave)
        case 6:  return 1.0; // 婚假 (Marriage Leave)
        case 7:  return 1.0; // 產假 (Maternity Leave)
        case 8:  return 1.0; // 侍產假 (Paternity Leave)
        case 9:  return 1.0; // 育嬰假 (Parental/Family Leave)
        case 10: return 1.0; // 喪假 (Bereavement Leave)
        case 11: return 1.0; // 陪審團 (Jury Service)
        case 12: return 0.0; // 離修假 (Sabbatical Leave)
        case 13: return 1.0; // 公司福利 (Company Benefits)
        case 14: return 0.0; // 其他 (Other)
        default: return 0.0;
      }
    })();
    setPayRatio(pay_ratio);
  }, [sel_leaveType]);

  useEffect(() => {
    refreshData();
  }, [sel_staff]);

  useEffect(() => {
    if ( moment(sel_leaveFrom).isAfter(sel_leaveTo) ) {
      setToDate(sel_leaveFrom);
    }
  }, [sel_leaveFrom]);

  const applyLeave = () =>
  {
    // condition
    if (!sel_staff.id) {
      PopMessage.show('請選擇一位同事', '警告', 'danger');
      return;
    }

    // confirm user
    if (!window.confirm('確定要批准假期?')) return;

    // execute
    let dto = {
      uid: sel_staff.id,
      type: sel_leaveType,
      pay_ratio: pay_ratio,
      from_dtm: Util.ShortDate(sel_leaveFrom),
      to_dtm: Util.ShortDate(sel_leaveTo),
    };
    API.applyLeave(dto).then(resp => {
      if (resp.success)
      {
        PopMessage.show('已成功處理員工假期申請記錄', '成功', 'success');
        refreshData();
      }
      else
      {
        PopMessage.show(resp.msg, '錯誤', 'danger');
      }
    });
  }



  return (<>
    <h1>日程 - 請假表</h1>
    <div>
      <p className="message blue">
        新增員工假期記錄，取得員工過去三個月至未來一個月的假期記錄。
      </p>
      <div className="row">
        <label className="search-field">
          <strong>員工</strong>
          <SearchableList items={staff}
            value={sel_staff} withDefault={{id: null, display_name: ' 請選擇 - '}}
            filter={(s,v) => -1<`${s.id}||${s.display_name}||${s.worker_code}`.indexOf(v.toUpperCase())}
            getTitle={s => s.id}
            getDesc={s => s.display_name}
            onChange={setStaff}
          />
        </label>
      </div>
      <Protected allow={['ADMIN','OPERATOR']}>
        <div className="row search-bar">
          <label className="search-field">
            <strong>由</strong>
            <DatePicker selected={sel_leaveFrom}
              onChange={setFromDate}
              dateFormat="dd-MM-yyyy"
            />
          </label>
          <label className="field-row">
            <strong>至</strong>
            <DatePicker selected={sel_leaveTo}
              minDate={ sel_leaveFrom }
              onChange={setToDate}
              dateFormat="dd-MM-yyyy"
            />
          </label>
          <label className="search-field">
            <strong>假期類型</strong>
            <select value={sel_leaveType} onChange={e=>setLeaveType(parseInt(e.target.value, 10))}>
              <option value="1">年假 (Annual Leave)</option>
              <option value="2">事假 (Casual Leave)</option>
              <option value="3">病假 (Sick Leave)</option>
              <option value="4">無薪假 (Unpaid Leave)</option>
              <option value="5">補假/恩恤假 (Compansationate Leave)</option>
              <option value="6">婚假 (Marriage Leave)</option>
              <option value="7">產假 (Maternity Leave)</option>
              <option value="8">侍產假 (Paternity Leave)</option>
              <option value="9">育嬰假 (Parental/Family Leave)</option>
              <option value="10">喪假 (Bereavement Leave)</option>
           {/*<option value="11">陪審團 (Jury Service)</option>
              <option value="12">離修假 (Sabbatical Leave)</option>*/}
              <option value="13">公司福利 (Company Benefits)</option>
              <option value="14">其他 (Other)</option>
            </select>
          </label>
          <label className="search-field">
            <strong>薪金比例</strong>
            <input type="number" value={pay_ratio} onChange={e=>setPayRatio(parseFloat(e.target.value))} />
          </label>
          <button className="btn green" id="btn-apply-leave"
            onClick={applyLeave}
            type="button">請假</button>
        </div>
      </Protected>
    </div>
    <div className="leave-table">
      { loading
        ?<Loading />
        :<LeaveTable leaves={leaves} refreshData={refreshData} />
      }
    </div>
  </>);


}

export default LeaveView;